import { ComponentProps } from 'react';
import Tooltip from 'antd/es/tooltip';

/**
 * OpTooltip is a wrapper around Ant Design's Tooltip component.
 * It displays a text popup when users hover over or focus on an element.
 * 
 * Use this component to provide additional context, explanations, or help text for UI elements
 * without cluttering the interface. Useful for icon buttons, truncated text, or any element
 * that benefits from additional information.
 * 
 * @example
 * <OpTooltip title="Click to save">
 *   <Button icon={<SaveOutlined />} />
 * </OpTooltip>
 * 
 */
export const OpTooltip = ({
  children,
  className = '',
  ...tooltipProps
}: ComponentProps<typeof Tooltip>) => {
  return (
    <Tooltip className={`op-tooltip ${className}`.trim()} {...tooltipProps}>
      {children}
    </Tooltip>
  );
};
